@if (rate !== undefined) {
  <div class="price">
    @if (isDisney) {
      <mb-expandable-panel #detailRate>
        <div class="roomsDisney">
          <div class="total-price">
            <div class="description">
              <p class="price-text">
                <strong>
                  @if (nameRoom === '') {
                    Habitación
                  } @else {
                    <ng-template #toolTipNameRoom>
                      {{ nameRoom }}
                    </ng-template>
                    <span
                      class="switch-tooltip-example"
                      [mb-tooltip]="toolTipNameRoom"
                      mbTooltipColor="light"
                      mbTooltipPosition="above"
                    >
                      <span>{{ nameRoom | ellipsis: 14 }}</span>
                    </span>
                  }
                </strong>
              </p>
            </div>
            @if (amountPerNight) {
              <span class="value">
                @if (showPriceSkeleton) {
                  <am-basic-skeleton></am-basic-skeleton>
                } @else {
                  <strong
                    >{{ currencyLabel }}
                    {{ (fixedPricePerNight ?? amountPerNight.withTaxes) | Currency }}</strong
                  >
                }
                <p>/noche</p>
              </span>
            }
          </div>
          <div class="detail-price">
            <div class="description-detail-price">
              <ul>
                <li>
                  <p>{{ quantityNights }} noches</p>
                </li>
                <li>
                  <p>
                    {{ quantityRooms }}
                    {{ quantityRooms > 1 ? 'habitación' : 'habitaciónes' }}
                  </p>
                </li>
                <li>
                  <p>{{ guests }} {{ guests > 1 ? 'personas' : 'persona' }}</p>
                </li>
              </ul>
            </div>
          </div>

          @if (mealPlanSelected.code !== MEAL_PLAN.ROOM_ONLY) {
            <div class="tickets-disney tickets-disney--without-divisor">
              <div class="total-price">
                <div class="description">
                  <p class="price-text">
                    <strong>Plan de comida</strong>
                  </p>
                </div>
              </div>
              <div class="detail-price">
                <div class="description-detail-price">
                  <ul>
                    <li>
                      <p>{{ mealPlanSelected.description }}</p>
                    </li>
                    <li>
                      <p>{{ guests }} {{ guests > 1 ? 'personas' : 'persona' }}</p>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          }
        </div>
        @if (ticketDays > 0) {
          <div class="tickets-disney">
            <div class="total-price">
              <div class="description">
                <p class="price-text">
                  <strong>Entradas</strong>
                </p>
              </div>
              <span class="value">
                @if (showPriceSkeleton) {
                  <am-basic-skeleton></am-basic-skeleton>
                } @else {
                  <strong>{{ currencyLabel }}{{ ticketAmount | Currency }}</strong>
                }
                <p>/total</p>
              </span>
            </div>
            <div class="detail-price">
              <div class="description-detail-price">
                <ul>
                  <li>
                    <p>{{ ticketDays }} días</p>
                  </li>
                  <li>
                    <p>{{ guests }} {{ guests > 1 ? 'personas' : 'persona' }}</p>
                  </li>
                  <li>
                    <p>{{ ticketName }}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        }
      </mb-expandable-panel>
    }
    @if (showDiscountPrice && amountPerNight) {
      <div class="original-price">
        <span
          >{{ currencyLabel }}
          <strong
            >{{
              (showAmountTotal ? amountTotal.without_promo : amountPerNight.without_promo)
                | Currency
            }}
          </strong>
        </span>
      </div>
    }
    @if (expandable) {
      <div class="detailRate-btn">
        <button (click)="showDetail()">Mostrar detalle</button>
      </div>
    }
    <div class="total-price total-price--with-margin">
      <div class="description">
        @if (!showAmountTotal && !isDisney) {
          <p class="price-text">
            <strong>Precio por noche </strong>
          </p>
        }
        @if (showAmountTotal || isDisney) {
          <p class="price-text">
            <strong>Precio total &nbsp;</strong>
          </p>
        }
      </div>
      <span class="value">
        {{ currencyLabel }}
        @if (!isDisney && amountPerNight) {
          <strong>
            {{ (showAmountTotal ? amountTotal.total : amountPerNight.total) | Currency }}
          </strong>
        }
        @if (showPriceSkeleton) {
          <am-basic-skeleton></am-basic-skeleton>
        } @else {
          @if (isDisney) {
            <strong>{{ amountTotal.withTaxes | Currency }}</strong>
          }
        }
      </span>
    </div>
    <div class="detail-price detail-price--with-margin">
      <div class="value-detail-price">
        @if (isDisney && amountPerNight && !showPriceSkeleton) {
          <p>Precio por noche &nbsp;</p>
          <p>{{ currencyLabel }}{{ (fixedPricePerNight ?? amountPerNight.withTaxes) | Currency }}</p>
        }
        @if (!isDisney && amountPerNight) {
          <p>
            <strong>
              {{ showAmountTotal ? 'Precio por noche' : 'Precio total' }}
              {{ currencyLabel }}{{ (showAmountTotal ? amountPerNight.total : amountTotal.total) | Currency }}
            </strong>
          </p>
        }
      </div>
      <div class="description-detail-price">
        @if (isArgentinian || (!isArgentinian && currencyCode != 'ARS')) {
          <p>Impuestos incluidos</p>
        }
        @if (fop === 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode == 'ARS') {
          <p>Podría cobrarse la percepción RG5617</p>
        }
        @if (fop !== 'PAY_AT_DESTINATION' && !isArgentinian && currencyCode == 'ARS') {
          <p>No se te cobrará la percepción RG5617</p>
        }
        <mb-icon
          icon="info"
          class="icon-focus"
          [class.disabled]="isBreakdownDetailExpanded"
          (click)="expandBreakdownDetail()"
        ></mb-icon>
      </div>
      @if (!showPriceSkeleton) {
        <div class="detail-price__no-taxes-price">
          <span class="detail-price__no-taxes-price__label">
            Precio sin impuestos nacionales
          </span>
          <span class="detail-price__no-taxes-price__price">
            {{ currencyLabel }} {{ rate.price.total_without_iva | Currency }}
          </span>
        </div>
      }
    </div>

    <am-pricing-expandable
      [rateId]="rate.id"
      [fop]="fop"
      [isExperts]="isExperts"
      [currencyCode]="currencyCode"
      [currencyLabel]="currencyLabel"
      (collapsed)="isBreakdownDetailExpanded = false"
      #pricingExpandable
    ></am-pricing-expandable>
  </div>
}
